<template>
  <div class="product__table product-table">
    <h3 v-if="title" class="product-table__title">{{ title }}</h3>
    <table class="product-table__table">
      <tbody>
        <template v-for="(item, i) in items">
          <tr v-if="item.name || item.value" class="product-table__row" :key="i">
            <td class="product-table__cell">{{ item.name }}</td>
            <td class="product-table__cell product-table__cell--value">{{ item.value }}</td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ProductTable',
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array
    }
  }
}
</script>

<style scoped lang="sass">

.product-table
  width: 100%

.product-table__table
  width: 100%
  color: $nd-label-color
  font-size: 13px
  font-weight: 400
  line-height: 15px
  border-spacing: 0
  border: 0

  +mmin($tablet)
    font-size: 14px
    line-height: 17px

.product-table__row

  &:nth-child(2n+1)
    background-color: #f8f8f8

.product-table__cell
  padding: 12px 18px
  border-collapse: collapse

  &--value
    color: $text-color

  &:nth-child(1)
    width: 60%

.product-table__title
  width: 100%
  color: $text-color
  font-size: 18px
  line-height: 23px
  font-weight: 500
  margin: 28px 0 20px

</style>
